import React from "react";

import { Column, format, Row, useCurrentViewPort, ViewPort } from "@gamedev-web/gamedev-sdk-core";
import { BasicButton, ButtonType } from "@gaming/xds-react-js";

import { getImage, ImageType } from "../../helpers/imageHelper";
import { useStrings } from "../../localization/localizationHelpers";
import { ContentBox, ContentBoxIcon } from "../ContentBox";
import * as styles from "./ProgramSelector.module.css";
import { idAzureName, idXboxName } from "./programSelectorUtils";

const renderProgramSelectionSignedOut = (
  logoImage: string,
  logoImageAltText: string,
  selectProgramFormat: string,
  programName: string,
  programDescription: string,
  currentViewPort: ViewPort,
  customButtonTitle?: string
) => {
  const programImage = <img src={logoImage} className={styles.image} alt={logoImageAltText} />;
  const titleAndButton = (
    <>
      <Column className={styles.largeColumn}>
        <h3 className={styles.programName}>{programName}</h3>
      </Column>
      <Column>
        <BasicButton
          className={styles.button}
          as={"button"}
          buttonType={ButtonType.Secondary}
          disabled={true}
        >
          {customButtonTitle ?? format(selectProgramFormat, programName)}
        </BasicButton>
      </Column>
    </>
  );
  const description = (
    <Column>
      <Row>
        <Column className={styles.largeColumn}>
          <p>{programDescription}</p>
        </Column>
        <Column />
      </Row>
    </Column>
  );
  return (
    <ContentBox className={styles.programBox}>
      {currentViewPort >= ViewPort.MD && (
        <Row>
          <Column className={styles.imageColumn}>{programImage}</Column>
          <Column className={styles.programInfoWrapper}>
            <Row>{titleAndButton}</Row>
            <Row>{description}</Row>
          </Column>
        </Row>
      )}
      {currentViewPort < ViewPort.MD && (
        <>
          <Row>{programImage}</Row>
          <Row>
            <Column className={styles.programInfoWrapper}>
              <Row>{titleAndButton}</Row>
              <Row>{description}</Row>
            </Column>
          </Row>
        </>
      )}
    </ContentBox>
  );
};

export const SignedOutNoSelectedProgram = () => {
  const [
    chooseAProgram,
    selectProgramFormat,
    creatorsProgram,
    idXboxProgramDescription,
    idAzureProgramDescription,
    creatorsProgramDescription,
    signInToUnlock,
    pitchProgram,
    pitchProgramDescription,
    otherOpportunities,
    pitchProgramButtonSelectProgram,
    idXboxProgramImageAltText,
    idAzureProgramImageAltText,
    pitchProgramImageAltText,
    creatorsProgramImageAltText,
  ] = useStrings(
    "chooseAProgram",
    "selectProgramFormat",
    "creatorsProgram",
    "idXboxProgramDescription",
    "idAzureProgramDescription",
    "creatorsProgramDescription",
    "signInToUnlock",
    "pitchProgram",
    "pitchProgramDescription",
    "otherOpportunities",
    "pitchProgramButtonSelectProgram",
    "idXboxProgramImageAltText",
    "idAzureProgramImageAltText",
    "pitchProgramImageAltText",
    "creatorsProgramImageAltText"
  );
  const currentViewPort = useCurrentViewPort();
  return (
    <>
      <ContentBox
        titleConfiguration={{
          title: chooseAProgram,
          disabled: true,
          rightSideText: signInToUnlock,
          icon: ContentBoxIcon.Lock,
          separatorBar: true,
        }}
      >
        {renderProgramSelectionSignedOut(
          getImage("idxboxlogo", ImageType.Png),
          idXboxProgramImageAltText,
          selectProgramFormat,
          idXboxName,
          idXboxProgramDescription,
          currentViewPort
        )}
        {renderProgramSelectionSignedOut(
          getImage("idazurelogo", ImageType.Png),
          idAzureProgramImageAltText,
          selectProgramFormat,
          idAzureName,
          idAzureProgramDescription,
          currentViewPort
        )}
        {renderProgramSelectionSignedOut(
          getImage("creatorslogo", ImageType.Png),
          creatorsProgramImageAltText,
          selectProgramFormat,
          creatorsProgram,
          creatorsProgramDescription,
          currentViewPort
        )}
      </ContentBox>
      <ContentBox
        titleConfiguration={{
          title: otherOpportunities,
          separatorBar: true,
        }}
      >
        {renderProgramSelectionSignedOut(
          getImage("pitchlogo", ImageType.Png),
          pitchProgramImageAltText,
          selectProgramFormat,
          pitchProgram,
          pitchProgramDescription,
          currentViewPort,
          pitchProgramButtonSelectProgram
        )}
      </ContentBox>
    </>
  );
};
